import { getTodoList } from "./api";
import { setTodos } from "./todosSlice";


export const fetchTodos = (forceRefresh = false) => async (dispatch, getState) => {
    const { todoList, lastFetch } = getState().todos;

    if (!forceRefresh && (Date.now() - lastFetch) < (24 * 60 * 60 * 1000)) return;

    try {

        const response = await getTodoList();

        if (response) {
            dispatch(setTodos(response));
        } else {
            console.info("No todos data returned");
        }

    } catch (error) {
        console.error("Error fetching todos:", error);
    }
}